const normalizeKey = (value) => String(value ?? '').trim().toLowerCase();

export function formatOrderVariantLabel(line = {}) {
  const payload = line?.selectedVariant || line?.variants;
  if (!payload || typeof payload !== 'object') return '';

  const fromMap = payload.selectedVariants;
  if (fromMap && typeof fromMap === 'object' && !Array.isArray(fromMap)) {
    const parts = Object.entries(fromMap)
      .sort(([a], [b]) => a.localeCompare(b))
      .map(([, value]) => String(value).trim())
      .filter(Boolean);
    if (parts.length) return parts.join(' · ');
  }

  const attrs = payload.attributes;
  if (Array.isArray(attrs) && attrs.length) {
    const parts = attrs
      .slice()
      .sort((a, b) => String(a.option_name).localeCompare(String(b.option_name)))
      .map((attr) => String(attr.option_value || '').trim())
      .filter(Boolean);
    if (parts.length) return parts.join(' · ');
  }

  const sku = String(payload.sku || '').trim();
  if (sku && !normalizeKey(sku).startsWith('color')) return sku;

  return '';
}

function pickUrl(candidate) {
  if (!candidate) return '';
  if (typeof candidate === 'string') {
    const trimmed = candidate.trim();
    return trimmed || '';
  }
  if (typeof candidate === 'object') {
    return (candidate.image || candidate.thumbnail || candidate.url || candidate.src || '').trim();
  }
  return '';
}

export function resolveOrderLineImage(line = {}) {
  const variant = line?.selectedVariant || line?.variants;
  const variantImages = variant?.images;
  if (Array.isArray(variantImages)) {
    for (const img of variantImages) {
      const url = pickUrl(img);
      if (url) return url;
    }
  }

  const lineImages = line?.images;
  if (Array.isArray(lineImages)) {
    for (const img of lineImages) {
      const url = pickUrl(img);
      if (url) return url;
    }
  }

  return pickUrl(line?.image);
}

export function orderLineKey(line, index = 0) {
  const id = line?._id || line?.productId || index;
  const sku = line?.selectedVariant?.sku || '';
  const variantLabel = formatOrderVariantLabel(line);
  return `${id}-${sku}-${normalizeKey(variantLabel)}-${index}`;
}
